export default __webpack_public_path__ + "static/media/company_logo_japanese_03.07bdf714.jpg";